import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=6955115d&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=6955115d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6955115d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6955115d')) {
      api.createRecord('6955115d', component.options)
    } else {
      api.reload('6955115d', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=6955115d&scoped=true&", function () {
      api.rerender('6955115d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hL6y5aYIk7wu/JS/comp/Paginate.vue"
export default component.exports